import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UiModule } from '../../../../../ui/ui.module';
import { PartnerService } from 'src/app/api/partner.service';
import { ParticipantService } from 'src/app/api/participant.service';
import { KnobModule } from 'primeng/knob';

@Component({
  selector: 'app-misc-stats',
  templateUrl: './misc-stats.component.html',
  styleUrls: ['./misc-stats.component.scss'],
  standalone: true,
  imports: [CommonModule, UiModule, KnobModule]
})
export class MiscStatsComponent implements OnInit {
  activePartnersPercentage: number = 0;
  activePartners: number = 0;
  totalPartners: number = 0;

  remainingParticipantsPercentage: number = 0;
  remainingParticipants: number = 0;
  remainingTrips: number = 0;
  totalParticipants: number = 0;
  totalTrips: number = 0;
  currentYear: number = new Date().getFullYear();

  constructor(
    private partnerService: PartnerService,
    private participantService: ParticipantService
  ) { }

  ngOnInit(): void {
    this.partnerService.getActivePartners().subscribe((response) => {
      this.activePartners = response.activePartnerships;
      this.totalPartners = response.totalPartnerships;
      this.activePartnersPercentage = Math.round((this.activePartners / this.totalPartners) * 100);
    });

    this.participantService.getRemainingParticipants().subscribe((response) => {
      this.remainingParticipants = response.remainingParticipants.attendees;
      this.remainingTrips = response.remainingParticipants.tripCount;
      this.totalParticipants = response.totalParticipants.attendees;
      this.totalTrips = response.totalParticipants.tripCount;
      this.remainingParticipantsPercentage = Math.round((this.remainingParticipants / this.totalParticipants) * 100);
    });
  }
} 